"use strict";

/**
 * Initializes the country selector module
 * @module countrySelector
 */

/**
 * Plain JS object that represents a country selector, global variables
 * @param {HTMLElement} countryBox - the country selector element
 * @param {HTMLElement} closeBtn - the close button element
 * @param {HTMLElement} openBtn - the open button element
 * @param {HTMLElement} overlay - the overlay element
 */

const countryBox = document.querySelector(".select-country");
const closeBtn = document.querySelector(".list-close");
const openBtn = document.querySelector(".open-btn");
const overlay = document.querySelector(".selector-overlay");

/**
 * Slide in/out the country selector
*/
const countrySelectorToggle = () => {
    document.body.classList.toggle("no-scroll");
    countryBox.classList.toggle("open");
    overlay.classList.toggle("active");
};

/**
 * Bind events to the country selector elements
 */
const bindEvents = () => {
    if (countryBox) {
        openBtn.addEventListener("click", countrySelectorToggle);
        closeBtn.addEventListener("click", countrySelectorToggle);
        overlay.addEventListener("click", function () {
            if (countryBox.classList.contains("open")) {
                countrySelectorToggle();
            }
        });
    }
};

module.exports = bindEvents;
